// extracted by mini-css-extract-plugin
module.exports = {"typing":"style_typing__203NC","dot":"style_dot__1YRwn"};